import React, { useContext } from 'react';
import { Auth0Context } from '../react-auth0-spa';

const withUser = WrappedComponent => props => {
  const { user, getTokenSilently, logout } = useContext(Auth0Context);

  return <WrappedComponent user={user} authToken={getTokenSilently()} logout={logout} {...props} />;
};

export default withUser;
